angular.module( 'acme.view.application.groups.users', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.groups.users.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var groupsUsers = {
        name: 'application.groups.users',
        url: '/:id/users',
        views: {
          "subview-main": {
            controller: 'GroupsUsersController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/groups/users/users.tpl.html'
          }
        },
        data: {
          pageTitle: 'Group Users',
          permissions: ['USER_GROUPS_UPDATE']
        },
        resolve: {
          GroupData: [ '$stateParams', 'ApiService', function($stateParams, ApiService) {
            return ApiService.groups.detail($stateParams.id);
          }]
        }
      };

    $stateProvider
      .state(groupsUsers);
});
